var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMove = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h34v34H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.879 2H32v31.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DFDFDF",
  fillRule: "nonzero",
  d: "M3 2h29v29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-5.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM27 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  fill: "#545454"
}))));
export default SvgMove;